<template>
  <RevButtonBase
    v-if="isEnabled"
    :class="isFestive ? 'bg-static-ai-hi' : 'bg-static-ai-mid'"
    class="text-onaction-default-mid body-2 hover:bg-static-ai-mid-hover relative flex items-center rounded-[9999px] px-12 h-36 w-fit shrink-0 whitespace-nowrap isolate"
    @click="handlePillClick"
  >
    <ShoppingAssistantFestiveSnow v-if="isFestive" :clip-radius-px="18" />
    <IconCommentWithSparkles size="16" class="relative z-10 mr-4 shrink-0" />
    <span class="relative z-10">{{ label }}</span>
  </RevButtonBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconCommentWithSparkles } from '@ds/icons/IconCommentWithSparkles'

import { useIsShoppingAssistantFestive } from '../../composables/useIsShoppingAssistantFestive'
import { useShoppingAssistantEntry } from '../../composables/useShoppingAssistantEntry'
import ShoppingAssistantFestiveSnow from '../ShoppingAssistantFestiveSnow/ShoppingAssistantFestiveSnow.vue'

import translations from './ShoppingAssistantGiftingPlpPill.translations'
import { useShoppingAssistantGiftingPlpPillEnabled } from './composables/useShoppingAssistantGiftingPlpPillEnabled/useShoppingAssistantGiftingPlpPillEnabled'

const props = defineProps<{ title: string }>()

const tracking = useTracking()
const i18n = useI18n()
const { isEnabled } = useShoppingAssistantGiftingPlpPillEnabled()
const isFestive = useIsShoppingAssistantFestive()

const label = computed(() =>
  i18n(translations.bestGiftIdeas, {
    category: props.title,
  }),
)

function handleLaunch() {
  tracking.trackClick({
    zone: 'ai_shopping_assistant_plp_gifting_pill',
    name: 'ai_shopping_assistant_opened',
    entryPoint: 'plp_gifting_pill',
    seeded: true,
  })
}

const { launch } = useShoppingAssistantEntry({
  entryPoint: 'plp_gifting_pill',
  onLaunch: handleLaunch,
})

function handlePillClick() {
  launch({
    message: label.value,
  })
}
</script>
